import { useState } from "react";
import { ChevronRight } from "lucide-react";

const TONE = {
  Everyone: "bg-emerald-50 text-emerald-700", "Public / members": "bg-emerald-50 text-emerald-700",
  "Signed-in members": "bg-sky-50 text-sky-700", "Admins & moderators": "bg-amber-50 text-amber-800", Staff: "bg-amber-50 text-amber-800",
  "Admins only": "bg-red-50 text-red-700", Admins: "bg-red-50 text-red-700", "Scheduled job": "bg-violet-50 text-violet-700",
};
export const AccessChip = ({ v }) => <span className={`inline-block text-[11px] font-semibold rounded-full px-2 py-0.5 whitespace-nowrap ${TONE[v] || "bg-slate-100 text-slate-600"}`}>{v}</span>;

export const PagesTable = ({ pages }) => (
  <div className="overflow-x-auto">
    <table className="w-full text-sm" data-testid="sitemap-pages">
      <thead><tr className="text-left text-xs uppercase tracking-wider text-slate-400 border-b border-slate-100">
        <th className="py-2 pr-4">Address</th><th className="py-2 pr-4">Who can see it</th><th className="py-2 pr-4">What it is</th><th className="py-2">Code</th>
      </tr></thead>
      <tbody>{pages.map((p) => (
        <tr key={p.path} className="border-b border-slate-50 align-top" data-testid={`sitemap-page-${p.path}`}>
          <td className="py-2 pr-4 font-mono text-[13px] text-[#12234A] whitespace-nowrap">
            {p.path.includes(":") || p.access !== "Everyone" ? p.path : <a href={p.path} target="_blank" rel="noreferrer" className="hover:text-[#F5551E] hover:underline">{p.path}</a>}
          </td>
          <td className="py-2 pr-4"><AccessChip v={p.access} /></td>
          <td className="py-2 pr-4 text-slate-600">{p.description || "—"}</td>
          <td className="py-2 font-mono text-xs text-slate-400">{p.component}</td>
        </tr>
      ))}</tbody>
    </table>
  </div>
);

export const StaffSections = ({ items }) => {
  const groups = items.reduce((g, s) => ({ ...g, [s.area]: [...(g[s.area] || []), s] }), {});
  return (
    <div className="grid md:grid-cols-2 gap-4" data-testid="sitemap-staff">
      {Object.entries(groups).map(([area, list]) => (
        <div key={area} className="rounded-xl border border-slate-200 p-4">
          <p className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-2">{area} <span className="text-slate-300">· {list.length}</span></p>
          <div className="flex flex-wrap gap-1.5">{list.map((s) => <span key={s.id} className="text-[13px] bg-slate-50 border border-slate-200 rounded-lg px-2 py-0.5 text-[#12234A]">{s.label}</span>)}</div>
        </div>
      ))}
    </div>
  );
};

const RouteGroup = ({ area, list, forceOpen }) => {
  const [open, setOpen] = useState(false);
  const show = open || forceOpen;
  return (
    <div className="border-b border-slate-100">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center gap-2 py-2 text-sm font-semibold text-[#12234A] hover:bg-slate-50" data-testid={`sitemap-route-group-${area}`}>
        <ChevronRight size={15} className={`transition-transform ${show ? "rotate-90" : ""}`} /> /{area.replace(" · ", "/")}
        <span className="ml-auto text-xs font-normal text-slate-400">{list.length}</span>
      </button>
      {show && (
        <ul className="pb-2 pl-6 space-y-1">{list.map((r) => (
          <li key={r.path + r.methods.join()} className="flex flex-wrap items-center gap-2 text-[13px]">
            {r.methods.map((m) => <span key={m} className="font-mono text-[10px] font-bold rounded bg-[#12234A] text-white px-1.5 py-0.5">{m}</span>)}
            <span className="font-mono text-slate-700">{r.path}</span><AccessChip v={r.access} />
            <span className="text-slate-400 truncate">{r.name}</span>
          </li>
        ))}</ul>
      )}
    </div>
  );
};

export const RoutesList = ({ routes, q }) => {
  const groups = routes.reduce((g, r) => ({ ...g, [r.area]: [...(g[r.area] || []), r] }), {});
  return <div data-testid="sitemap-routes">{Object.entries(groups).map(([a, l]) => <RouteGroup key={a} area={a} list={l} forceOpen={!!q} />)}</div>;
};
